

















































































import {
	differenceInCalendarDays, differenceInDays, differenceInHours, parse,
} from 'date-fns';
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';

import ReservationQuoteDetailsPopover from '@/components/ReservationQuoteDetailsPopover.vue';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';

const Setup = Vue.extend({
	name: 'ReservationQuoteDetails',
	components: { ReservationQuoteDetailsPopover },
	computed: {
		...mapState('reservation', ['reservation']),
		...mapGetters('reservation', ['quote']),
	},
});

@Component
export default class ReservationQuoteDetails extends Setup {
	// Vuex
	public reservation!: Reservation;
	public quote!: Quote;

	// Computed
	public get chargeLength(): string {
		const isCalendarDay = this.quote.details.calendar_day;
		const calendarText = isCalendarDay ? 'calendar ' : '';
		const days = this.quote.details.days;
		const hours = this.quote.details.hours;
		let duration = 'Charged for ';

		if (days) {
			duration += `${days} ${calendarText}day${days > 1 ? 's' : ''} `;
		}

		if (hours > 0) {
			duration += `${hours} hour${hours > 1 ? 's' : ''} `;
		}

		return duration;
	}

	public get checkInDate(): string {
		return this.quote.is_event ? this.quote.event_dates[0] : (this.reservation.start_date || '');
	}

	public get checkinFormat(): String {
		let format = 'MMM D, YYYY';

		if (!this.settings.hide_res_start_time_details) {
			format += ' h:mm a';
		}

		return format;
	}

	public get checkOutDate(): string {
		return this.quote.is_event ? this.quote.event_dates[1] : (this.reservation.end_date || '');
	}

	public get checkoutFormat(): String {
		let format = '';

		if (!this.settings.hide_res_end_date_details) {
			format += 'MMM D, YYYY';
		}

		if (!this.settings.hide_res_end_time_details) {
			format += ' h:mm a';
		}

		return format;
	}

	public get dueAtLot(): number {
		if (this.reservation.auto_key) {
			return this.quote.balance_due;
		}

		return this.quote.due_at_lot;
	}

	public get dueText(): string {
		if (this.reservation.auto_key && this.reservation.prepaid && this.settings.adjustable_prepay) {
			if (this.quote.balance_due > 0) {
				return 'To be Charged';
			}

			if (this.quote.balance_due < 0) {
				return 'To be Refunded';
			}
		}

		return 'Due at Lot';
	}

	public get prepay(): number {
		if (this.reservation.auto_key) {
			return this.quote.prepaid;
		}

		return this.quote.prepay_amount;
	}

	public get settings(): Locations.Settings {
		return this.$store.getters['location/settings'];
	}

	public get shortcodeAttrs(): { [key: string]: string } {
		return this.$store.state.reservation.shortcodeAttrs;
	}

	public get stayLength(): string {
		const isCalendarDay = this.quote.details.calendar_day;
		const calendarText = isCalendarDay ? 'calendar ' : '';
		const startDate = parse(this.checkInDate);
		const endDate = parse(this.checkOutDate);
		const days = isCalendarDay ? differenceInCalendarDays(endDate, startDate) + 1 : differenceInDays(endDate, startDate);
		let hours = !isCalendarDay ? differenceInHours(endDate, startDate) : 0;
		let duration = 'Staying for ';

		if (days) {
			hours -= days * 24;
			duration += `${days} ${calendarText}day${days > 1 ? 's' : ''} `;
		}

		if (hours > 0) {
			duration += `${hours} hour${hours > 1 ? 's' : ''} `;
		}

		return duration;
	}
}
